import { render, staticRenderFns } from "./MenuOptionForm.vue?vue&type=template&id=784491dc"
import script from "./MenuOptionForm.vue?vue&type=script&lang=js"
export * from "./MenuOptionForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports